<div [formGroup]="form" class="send-box">
    <!-- <form > -->
        <label>Subject *</label>
        <input class="send-input" formControlName="subject" />
        <label>To *</label>
        <!-- <input class="send-input" type="text" name="to"/> -->
        <app-helpers-forms-input-emails-autocomplete [emailsControl]="emails" [limit]="maxEmails"></app-helpers-forms-input-emails-autocomplete>
    <!-- </form> -->
    <label>Your message *</label>
    <core-helpers-forms-wysiwyg-extended
        [content]="defaultMessage"
        [replaceableContent]="true"
        [emojis]="false"
        (textChange)="onMessageChange($event)"
    ></core-helpers-forms-wysiwyg-extended>
    <core-files-selected-box
        [title]="'Your selected file' + (files.length > 1 ? 's':'')"
        [files]="files"
        [fileActionText]="''"
    ></core-files-selected-box>
</div>
